import { Modal } from '../components/Modal';
import { formatShortcut, useActiveShortcuts } from '../lib/keys';
import { useUiStore } from '../stores/ui';

/** Alt+H — lists every binding active on the current screen, Tally-style discoverability. */
export function CheatSheetOverlay() {
  const open = useUiStore((s) => s.cheatSheetOpen);
  const setOpen = useUiStore((s) => s.setCheatSheetOpen);
  const scopes = useActiveShortcuts();

  return (
    <Modal open={open} onClose={() => setOpen(false)} title="Keyboard shortcuts" widthClassName="max-w-lg">
      <div className="flex flex-col gap-4">
        {scopes.map((scope) => (
          <div key={scope.label}>
            <h3 className="mb-1 text-[11px] font-medium uppercase tracking-wide text-[var(--text-dim)]">{scope.label}</h3>
            <table className="w-full text-[12.5px]">
              <tbody>
                {scope.shortcuts.map((s) => (
                  <tr key={s.id} className="border-b border-[var(--border)] last:border-b-0">
                    <td className="py-1 pr-3 text-[var(--text-dim)]">{s.description}</td>
                    <td className="py-1 text-right">
                      <span className="kbd">{formatShortcut(s)}</span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ))}
        {scopes.length === 0 && <p className="text-[12.5px] text-[var(--text-faint)]">No shortcuts registered on this screen.</p>}
      </div>
    </Modal>
  );
}
